// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: true,
  domain: "https://api.followup-learning.globis.co.jp/",
  appId: "1700284563325255",
  fb_version: 'v2.12',
  my_domain: 'http://after-training.globis.co.jp',
  //images_domain: 'https://s3-ap-northeast-1.amazonaws.com/after-training.globis.co.jp/'
  images_domain: 'https://followup-learning.globis.co.jp/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts